import {H2SectionComponent} from "../../../app/components/section/SectionComponent";
import {ProblemSetNote} from "./ProblemSetNote";
import React from "react";

export function ProblemSetComponent({dataStructure, children}) {
    return (
        <H2SectionComponent header="Problem Set">
            <ProblemSetNote dataStructure={dataStructure}/>
            {children}
        </H2SectionComponent>
    )
}